<div class="modal-content">
    <div class="modal-header">
        <h6 class="modal-title" id="vcenter">
            Maps</h6>
        <a (click)="modal.close('')" type="button" class="close">×</a>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-lg-8 col-md-8 col-sm-12">
                <div id="map" style="height: 332px;width: 100%;"></div>
                <ng-template #bkgOpacity>
                    <div width="100%" style="background-color: #e9ecef; height: 332px;">
                        &nbsp;
                    </div>
                </ng-template>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group has-float-label">
                    <input type="text" class="form-control" [(ngModel)]="mapCenter.lat" />
                    <label>{{'map_selection.latitude'|translate}}</label>
                </div>
                <div class="form-group has-float-label">
                    <input type="text" class="form-control" [(ngModel)]="mapCenter.lng" />
                    <label>{{'map_selection.longitude'|translate}}</label>
                </div>
                <div class="form-group has-float-label">
                    <textarea type="text" class="form-control" [(ngModel)]="mapCenter.address"></textarea>
                    <label>{{'map_selection.address'|translate}}</label>
                </div>
                <button (click)="add()" class="btn btn-danger claroredbg">{{'map_selection.add'|translate}}</button>
            </div>
        </div>
    </div>
</div>